import { Flex, Spacer, Button, Text, Box, Icon, Link } from '@chakra-ui/react';

import { useAuth0 } from '@auth0/auth0-react';

import { useLocation, useNavigate } from 'react-router-dom';
import HybleLogo from './svgs/HybleLogo';
import ToolkitIcon from './svgs/Toolkit';
import { colors } from '../theme/colors';
import ChevronLeft from './svgs/ChevronLeft';
import QuestionMark from './svgs/QuestionMark';
import Logout from './svgs/Logout';

interface HeaderProps {
  onBackClick?: () => void;
}

const Header = ({ onBackClick }: HeaderProps) => {
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const { state } = useLocation();

  const backLink = state?.backLink;
  const backLinkText = state?.backLinkText;

  const toolkitURL = window.ENV_CONFIG.mrmToolkitUrl;

  const handleClick = () => {
    if (onBackClick) {
      onBackClick();
    } else if (backLink) {
      navigate(backLink);
    }
  };

  return (
    <Flex
      h="60px"
      bg="colors.darkestTeal"
      alignItems="center"
      zIndex="10"
      px="24px"
      position={'sticky'}
      top={0}
      boxShadow="0px 4px 20px 0px rgba(0, 0, 0, 0.25)"
    >
      <Flex gap={5} alignItems="center">
        <Button
          onClick={() => navigate('/')}
          background="none"
          padding="0"
          _hover={{ bgColor: 'none' }}
          _active={{ bgColor: 'none' }}
        >
          <HybleLogo />
        </Button>
        <Link href={toolkitURL} isExternal>
          <Icon w={6} h={6} as={ToolkitIcon} />
        </Link>

        <Box bgColor={colors.darkGreyishTeal} h={'30px'} w={'1px'} />
      </Flex>
      {backLink ? (
        <Button
          variant="ghost"
          sx={buttonStyles}
          pb="2px"
          pl={2}
          _hover={{ bg: 'none' }}
          _focus={{ bg: 'none' }}
          _active={{ bg: 'none' }}
          onClick={handleClick}
        >
          <Icon as={ChevronLeft} w={8} h={13} />
          <Text color="white" fontSize="14px" fontWeight="700">
            {backLinkText}
          </Text>
        </Button>
      ) : (
        <Link href={toolkitURL} sx={buttonStyles}>
          <Flex align={'center'} pl={2}>
            <Icon as={ChevronLeft} w={8} h={13} />
            <Text color="white" fontSize="14px" fontWeight="700">
              Back to Toolkit
            </Text>
          </Flex>
        </Link>
      )}

      <Spacer />

      <Flex
        align={'center'}
        gap={4}
        style={{ cursor: 'pointer' }}
        color={'colors.mrmMedTeal'}
      >
        <Link
          href={'https://support.hyble.tech/'}
          isExternal
          _hover={{ color: 'colors.mrmTeal' }}
          data-heap="header_supportButton"
          data-testid="support-button"
          rel="noreferrer"
        >
          <Icon w="24px" h="24px" as={QuestionMark} />
        </Link>

        <Box
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
          _hover={{ color: 'colors.mrmMedDarkTeal' }}
        >
          <Icon data-testid="header-logout" as={Logout} w="24px" h="24px" />
        </Box>
      </Flex>
    </Flex>
  );
};

export default Header;

const buttonStyles = {
  color: 'white',
  fontSize: '14px',
  fontWeight: '700',
  _hover: { opacity: 0.7 },
};
